import {showMsg, clearMsg} from './shared';
import { global } from './state.js'

export const auth = {};

export function from(url, opts, data) {

  opts = opts || {
    method: "POST"
  };

  opts.body = opts.body || opts.data || data;

  const debugFails = opts.debugFails || false;
  
  // console.log("fetch", opts.method || "GET", url, opts)

  if ((auth.tokens && auth.tokens.id_token))  {
    opts.headers = opts.headers || { 
      "authorization": "Bearer "+ auth.tokens.id_token
    }
    showMsg("Loading..")
  } else {
    // console.log("from -- attempt to fetch without auth")
    if (global.noauth) {
      showMsg("Loading..")
    } else {
      showMsg("Loading with no auth..")
    }
  }

  return fetch(url, opts)
  .then(r => {
    if (debugFails) {
      console.log("from : debugFails=true : ", url, r.status, opts);
    } else if (r.status == 401 || r.status == 403) {
      if (global.noauth) {
        showMsg("An error occured, please try later. Support notified.")
      } else {
        window.tokens = null;
        window.sessionStorage.clear();
        window.location.reload();
      }
    }
    // console.log("from", opts.method || "GET", r.status, r.url)
    clearMsg();
    return r;
  })
}